// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"700de1bb","292":"7e1f9f4a","367":"e0114d4f","418":"77d50ed8","938":"b27a5e78"}[chunkId] + ".chunk.js";
};